import type { ReactNode } from "react";

type MiBoardStatusPageProps = {
  code: string;
  title: string;
  description: string;
  primaryLabel: string;
  primaryHref: string;
  secondaryLabel?: string;
  secondaryHref?: string;
  icon?: ReactNode;
};

export const MiBoardStatusPage = ({
  code,
  title,
  description,
  primaryLabel,
  primaryHref,
  secondaryLabel,
  secondaryHref,
  icon,
}: MiBoardStatusPageProps) => {
  return (
    <main className="miboard-status-page">
      <section className="miboard-status-page__card" aria-labelledby="status-title">
        <div className="miboard-status-page__badge">{code}</div>
        <div className="miboard-status-page__icon" aria-hidden="true">
          {icon || (
            <svg viewBox="0 0 64 64" fill="none">
              <circle cx="32" cy="32" r="27" stroke="currentColor" strokeWidth="3.5" />
              <path
                d="M32 18v16l10 6"
                stroke="currentColor"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
        <h1 id="status-title" className="miboard-status-page__title">
          {title}
        </h1>
        <p className="miboard-status-page__description">{description}</p>
        <div className="miboard-status-page__actions">
          <a className="miboard-status-page__primary" href={primaryHref}>
            {primaryLabel}
          </a>
          {secondaryLabel && secondaryHref ? (
            <a className="miboard-status-page__secondary" href={secondaryHref}>
              {secondaryLabel}
            </a>
          ) : null}
        </div>
      </section>
    </main>
  );
};
